import React, { useState } from "react";
import {
    Button,
    Form,
    Input,
    Select,
    message,
    Card,
    Row,
    Col,
    Typography,
    Space,
} from "antd";
import {
    SaveOutlined,
    ReloadOutlined,
    UserOutlined,
    PhoneOutlined,
    MailOutlined,
    EnvironmentOutlined,
} from "@ant-design/icons";
import { createLawyerApi } from "../../../api/master.api";

const { Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const COURT_OPTIONS = [
    "আপিল বিভাগ এবং হাইকোর্ট বিভাগ",
    "আপিল বিভাগ",
    "হাইকোর্ট বিভাগ",
    "ঢাকা জেলা জজ আদালত",
    "চট্রগ্রাম জেলা জজ আদালত",
    "টাঙ্গাইল জেলা জজ আদালত",
    "মুন্সিগঞ্জ জেলা জজ আদালত",
];

const LAWYER_TYPES = [
    { value: "আইন উপদেষ্টা", label: "আইন উপদেষ্টা" },
    { value: "প্যানেল আইনজীবী", label: "প্যানেল আইনজীবী" },
];

const LawyerEntry = () => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (values) => {
        setSubmitting(true);
        try {
            await createLawyerApi({
                ...values,
                status: values.status || "active",
            });
            message.success("তথ্য সফলভাবে সংরক্ষণ করা হয়েছে");
            form.resetFields();
        } catch (err) {
            console.error(err);
            message.error("সংরক্ষণ ব্যর্থ হয়েছে");
        } finally {
            setSubmitting(false);
        }
    };

    const handleReset = () => {
        form.resetFields();
        message.info("ফর্ম রিসেট করা হয়েছে");
    };

    return (
        <div style={{ background: "#f0f2f5", minHeight: "100vh", padding: "24px" }}>
            <div style={{ maxWidth: 1200, margin: "0 auto" }}>
                {/* Header */}
                <Card
                    style={{
                        marginBottom: 24,
                        borderRadius: 12,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    }}
                    bodyStyle={{ padding: "20px 24px" }}
                >
                    <Row justify="space-between" align="middle">
                        <Col>
                            <Title level={3} style={{ margin: 0, color: "#1a5f7a" }}>
                                আইন উপদেষ্টা / প্যানেল আইনজীবী এন্ট্রি
                            </Title>
                            <div style={{ marginTop: 8, color: "#666" }}>
                                নতুন আইন উপদেষ্টা বা প্যানেল আইনজীবীর তথ্য সংরক্ষণ করুন
                            </div>
                        </Col>
                    </Row>
                </Card>

                <Form
                    layout="vertical"
                    form={form}
                    onFinish={handleSubmit}
                    initialValues={{ status: "active" }}
                >
                    {/* Section 1: Basic Information */}
                    <Card
                        title={
                            <Space>
                                <UserOutlined style={{ color: "#1a5f7a" }} />
                                <span>ব্যক্তিগত ও পেশাগত তথ্য</span>
                            </Space>
                        }
                        variant="outlined"
                        style={{ marginBottom: 24, borderRadius: 12 }}
                        headStyle={{ backgroundColor: "#fafafa", borderBottom: "2px solid #1a5f7a", borderRadius: "12px 12px 0 0" }}
                    >
                        <Row gutter={24}>
                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="lawyer_name"
                                    label="আইনজীবীর নাম"
                                    rules={[
                                        { required: true, message: "নাম প্রদান করুন" },
                                        { min: 2, message: "কমপক্ষে ২ অক্ষর দিন" }
                                    ]}
                                >
                                    <Input
                                        placeholder="আইনজীবীর নাম লিখুন"
                                        size="large"
                                        prefix={<UserOutlined style={{ color: "#bfbfbf" }} />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item name="father_name" label="পিতা/স্বামীর নাম">
                                    <Input
                                        placeholder="পিতা বা স্বামীর নাম লিখুন"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="lawyer_type"
                                    label="আইনজীবীর ধরন"
                                    rules={[{ required: true, message: "ধরন নির্বাচন করুন" }]}
                                >
                                    <Select
                                        placeholder="ধরন নির্বাচন করুন"
                                        size="large"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {LAWYER_TYPES.map((type) => (
                                            <Option key={type.value} value={type.value}>
                                                {type.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="court_name"
                                    label="আদালতের নাম"
                                    rules={[{ required: true, message: "আদালত নির্বাচন করুন" }]}
                                >
                                    <Select
                                        allowClear
                                        placeholder="আদালত নির্বাচন করুন"
                                        size="large"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {COURT_OPTIONS.map((court) => (
                                            <Option key={court} value={court}>
                                                {court}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item name="court_category" label="কোর্ট ক্যাটাগরি">
                                    <Input
                                        placeholder="ক্যাটাগরি লিখুন"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>

                    {/* Section 2: Contact Information */}
                    <Card
                        title={
                            <Space>
                                <PhoneOutlined style={{ color: "#1a5f7a" }} />
                                <span>যোগাযোগের তথ্য</span>
                            </Space>
                        }
                        variant="outlined"
                        style={{ marginBottom: 24, borderRadius: 12 }}
                        headStyle={{ backgroundColor: "#fafafa", borderBottom: "2px solid #1a5f7a" }}
                    >
                        <Row gutter={24}>
                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="mobile_no"
                                    label="মোবাইল নম্বর"
                                    rules={[
                                        { required: true, message: "মোবাইল নম্বর দিন" },
                                        { pattern: /^01[3-9]\d{8}$/, message: "সঠিক মোবাইল নম্বর দিন (01XXXXXXXXX)" }
                                    ]}
                                >
                                    <Input
                                        placeholder="০১XXXXXXXXX"
                                        size="large"
                                        prefix={<PhoneOutlined style={{ color: "#bfbfbf" }} />}
                                        maxLength={11}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item name="email" label="ইমেইল এড্রেস">
                                    <Input
                                        type="email"
                                        placeholder="example@mail.com"
                                        size="large"
                                        prefix={<MailOutlined style={{ color: "#bfbfbf" }} />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item name="status" label="বর্তমান স্ট্যাটাস">
                                    <Select size="large">
                                        <Option value="active">✅ Active</Option>
                                        <Option value="inactive">❌ Inactive</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>

                    {/* Section 3: Addresses */}
                    <Card
                        title={
                            <Space>
                                <EnvironmentOutlined style={{ color: "#1a5f7a" }} />
                                <span>ঠিকানা</span>
                            </Space>
                        }
                        variant="outlined"
                        style={{ marginBottom: 24, borderRadius: 12 }}
                        headStyle={{ backgroundColor: "#fafafa", borderBottom: "2px solid #1a5f7a" }}
                    >
                        <Row gutter={24}>
                            <Col xs={24} md={8}>
                                <Form.Item name="present_address" label="বর্তমান ঠিকানা">
                                    <TextArea
                                        rows={4}
                                        placeholder="বর্তমান ঠিকানা লিখুন"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item name="permanent_address" label="স্থায়ী ঠিকানা">
                                    <TextArea
                                        rows={4}
                                        placeholder="স্থায়ী ঠিকানা লিখুন"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item name="chamber_address" label="চেম্বারের ঠিকানা">
                                    <TextArea
                                        rows={4}
                                        placeholder="চেম্বারের ঠিকানা লিখুন"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>

                    {/* Action Buttons */}
                    <Card
                        style={{
                            borderRadius: 12,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            backgroundColor: "#fff",
                        }}
                        bodyStyle={{ padding: "16px 24px" }}
                    >
                        <Row justify="end">
                            <Space size="middle">
                                <Button
                                    size="large"
                                    onClick={handleReset}
                                    icon={<ReloadOutlined />}
                                >
                                    রিসেট করুন
                                </Button>
                                <Button
                                    type="primary"
                                    size="large"
                                    htmlType="submit"
                                    loading={submitting}
                                    icon={<SaveOutlined />}
                                    style={{
                                        backgroundColor: "#1a5f7a",
                                        borderColor: "#1a5f7a",
                                        minWidth: 140,
                                    }}
                                >
                                    সংরক্ষণ করুন
                                </Button>
                            </Space>
                        </Row>
                    </Card>
                </Form>
            </div>
        </div>
    );
};

export default LawyerEntry;